import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  approveGICredit,
  balanceOfGICredit,
  buyGICredit,
} from "@/helper/contractFunctions/MafiaGICredit";
import { createGIRequest } from "@/helper/contractFunctions/MafiaGIManager";

export interface GameIntelligenceState {
  giCreditBalance: number;
  isBuyingGICredit: boolean;
  isCreatingGIRequest: boolean;
}

const initialState: GameIntelligenceState = {
  giCreditBalance: 0,
  isBuyingGICredit: false,
  isCreatingGIRequest: false,
};

export const getGICreditBalanceAction = createAsyncThunk(
  "gameIntelligence/getGICreditBalanceAction",
  async ({ account, signature, signMsg }: { account: string; signature: string; signMsg: string }) =>
    balanceOfGICredit(account, signMsg, signature)
);

export const buyGICreditAction = createAsyncThunk(
  "gameIntelligence/buyGICreditAction",
  async ({ account, swapTokenId, tokenAddress, tokenAmount, amount }: { account: string; swapTokenId: number; tokenAddress: string; tokenAmount: number; amount: number }) => {
    const data = await buyGICredit(swapTokenId, tokenAddress, tokenAmount, amount, account);
    return data.transactionHash;
  }
);
export const createGIRequestAction = createAsyncThunk(
  "gameIntelligence/createGIRequestAction",
  async ({
    account,
    target,
    assetType,
    cityId,
  }: {
    account: string;
    target: string;
    assetType: number;
    cityId: number;
  }) => {
    const data = await createGIRequest(account, target, assetType, cityId);
    return data.transactionHash;
  }
);

export const approveGICreditAction = createAsyncThunk(
  "gameIntelligence/approveGICreditAction",
  async ({
    account,
    target,
    amount,
  }: {
    account: string;
    target: string;
    amount: number;
  }) => {
    const data = await approveGICredit(target, amount, account);
    return data.transactionHash;
  }
);

const gameIntelligenceSlice = createSlice({
  name: "gameIntelligence",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGICreditBalanceAction.fulfilled, (state, { payload }) => {
        state.giCreditBalance = Number(payload);
      })
      .addCase(buyGICreditAction.pending, (state) => {
        state.isBuyingGICredit = true;
      })
      .addCase(buyGICreditAction.fulfilled, (state) => {
        state.isBuyingGICredit = false;
      })
      .addCase(buyGICreditAction.rejected, (state) => {
        state.isBuyingGICredit = false;
      })
      .addCase(createGIRequestAction.pending, (state) => {
        state.isCreatingGIRequest = true;
      })
      .addCase(createGIRequestAction.fulfilled, (state) => {
        state.isCreatingGIRequest = false;
      })
      .addCase(createGIRequestAction.rejected, (state, { error }) => {
        state.isCreatingGIRequest = false;
        console.log(error.message);
      });
  },
});

export default gameIntelligenceSlice.reducer;